import React, { FunctionComponent, useEffect, useState } from 'react'
import { useFeathersClient } from '@strac/react-client-feathers'
import { Statistic } from 'antd'

interface IProps {
  serviceName: string
  title: string
  query?: {
    $limit: 0
  }
}

const FeathersServiceStatistic: FunctionComponent<any> = (props: IProps) => {
  const { serviceName, title, query } = props

  const client = useFeathersClient()

  const [total, setTotal] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    setLoading(true)
    client
      .service(serviceName)
      .find({
        query
      })
      .then((result: any) => {
        setTotal(result.total)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [client, serviceName, query])

  return <Statistic title={title} value={total} loading={loading} />
}

export default FeathersServiceStatistic
